export const ASSET_LOG_LIST_REQUEST = "ASSET_LOG_LIST_REQUEST"; 
export const ASSET_LOG_LIST_SUCCESS = "ASSET_LOG_LIST_REQUEST_SUCCESS";

export const READ_ASSET_LOG = 213012;